/**
 * Builds an impersonation URL with a target-specific subdomain so each iframe
 * gets a unique origin, naturally isolating cookies and storage between sessions.
 *
 * Example: `https://hcp.clipboard.health` + targetId `abc123`
 *   → `https://abc123.hcp.clipboard.health/impersonate?username=...`
 */
export function buildImpersonationUrl(
  baseAppUrl: string,
  targetId: string,
  cognitoUsername: string
): string {
  const url = new URL(baseAppUrl);
  url.hostname = `${targetId}.${url.hostname}`;
  url.pathname = "/impersonate";
  url.searchParams.set("username", cognitoUsername);
  return url.toString();
}
